import React, { useState } from "react";
import { FiEye, FiEyeOff } from "react-icons/fi";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { BaseUrl } from "../..";
import topTost from "../../utils/topTost";
const LoginForm = ({ resetPath }) => {
  const [login, setLogin] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [isAdmin, setIsAdmin] = useState("1");
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const M_id = queryParams.get("id");

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("login_id", login);
    formData.append("password", password);
    formData.append("isAdmin", isAdmin ? "1" : "");

    try {
      const response = await fetch(`${BaseUrl}login`, {
        method: "POST",
        body: formData,
      });

      const data = await response.json();

      if (response.ok && data.access_token) {
        localStorage.setItem("access_token", data.access_token);
        localStorage.setItem("IsAdmin", data.user.IsAdmin);
        localStorage.setItem("roleId", data.user.roleId);
        localStorage.setItem("id", data.user.id);
        localStorage.setItem("name", data.user.name);
        localStorage.setItem("number", data.user.number);
        localStorage.setItem("roleName", data.user.roleName);
        localStorage.setItem("BranchId", data.user.BranchId);

        topTost({
          title: "Login successful!",
          icon: "success",
        });
        navigate(`/home?id=${1}`);
      } else {
        topTost({
          title: data?.message || "Invalid login credentials",
          icon: "error",
        });
      }
    } catch (error) {
      console.error("Login failed:", error);
      topTost({
        title: "Login failed. Please try again later.",
        icon: "error",
      });
    }
  };

  return (
    <>
      <h2 className="fs-20 fw-bolder mb-4">Login</h2>
      {/* <h4 className="fs-13 fw-bold mb-2">Login to your account</h4> */}
      <p className="fs-12 fw-medium text-muted">
        Welcome ! At <strong> Loan Matrix,</strong> we're here to help you
        manage your leads, customers, collections, and team with ease.
      </p>
      <form className="w-100 mt-4 pt-2" onSubmit={handleSubmit}>
        <div className="mb-4">
          <input
            type="text"
            className="form-control"
            placeholder="Enter User Id"
            defaultValue="wrapcode.info@gmail.com"
            value={login}
            onChange={(e) => {
              const value = e.target.value;
              if (/^\d+$/.test(value)) {
                // If allow max 10
                if (value.length <= 10) {
                  setLogin(value);
                }
              } else {
                // If email allow
                setLogin(value);
              }
            }}
            required
          />
        </div>
        <div className="mb-3 position-relative">
          <input
            type={showPassword ? "text" : "password"}
            className="form-control"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <span
            className="position-absolute top-50 end-0 translate-middle-y me-3 text-muted"
            style={{ cursor: "pointer" }}
            onClick={() => setShowPassword(!showPassword)}
          >
            {showPassword ? <FiEyeOff /> : <FiEye />}
          </span>
        </div>

        <div className="d-flex align-items-center justify-content-between">
          <div>
            <Link to="/reset-password" className="fs-11 text-primary">
              Forget password ?
            </Link>
          </div>
        </div>
        <div className="mt-5">
          <button type="submit" className="btn btn-lg btn-primary w-100">
            Login
          </button>
        </div>
      </form>
    </>
  );
};

export default LoginForm;
